import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import SvgExternalLink from 'src/components/Svgs/SvgExternalLink'
import Tooltip from 'src/components/Tooltip/Tooltip'
import UserAvatarOrganizationAndName from 'src/components/UserAvatarOrganizationAndName/UserAvatarOrganizationAndName'
import Trns from 'src/localization/Trns'
import { OrganizationsListModel } from 'src/models/organizations.models'
import { css } from 'styled-components'

interface OutOfPocketExpensesBoxContentProps {
  organization: OrganizationsListModel
}

const OutOfPocketExpensesBoxContent: React.FC<
  OutOfPocketExpensesBoxContentProps
> = (props): React.ReactElement => {
  const { organization } = props

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          row-gap: 40px;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              12,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )}
          `}
        >
          <Trns
            source={
              'Assign an Owner, Admin, or Bookkeeper to approve reimbursement requests across your organization.'
            }
          />
        </span>
        <div
          css={css`
            display: flex;
            flex-direction: column;
          `}
        >
          <span
            css={css`
              ${getFontCss(
                14,
                styleConstants.colors.gray_darkest,
                styleConstants.fontFamilies.regular,
              )};
              display: flex;
              align-items: center;
            `}
          >
            <Trns source={'Reimbursements'} />
          </span>
          <span
            css={css`
              ${getFontCss(
                16,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )};
            `}
          >
            <Trns
              source={organization.isOutOfPocketExpensesVisible ? 'ON' : 'OFF'}
            />
          </span>
        </div>
        {organization.isOutOfPocketExpensesVisible && (
          <div
            css={css`
              display: flex;
              flex-direction: column;
            `}
          >
            <span
              css={css`
                ${getFontCss(
                  14,
                  styleConstants.colors.gray_darkest,
                  styleConstants.fontFamilies.regular,
                )};
                display: flex;
                margin-bottom: 8px;
              `}
            >
              <Trns source={'Approver'} />
            </span>
            {organization.expenseApprover !== undefined ? (
              <UserAvatarOrganizationAndName
                user={organization.expenseApprover}
              />
            ) : (
              <span
                css={css`
                  ${getFontCss(
                    16,
                    themeConstants.colors.font_primary,
                    styleConstants.fontFamilies.regular,
                  )};
                `}
              >
                <Trns source={'No Approver Assigned'} />
              </span>
            )}
            <div
              css={css`
                display: flex;
                flex-direction: column;
                row-gap: 16px;
                margin-top: 20px;
              `}
            >
              <span
                css={css`
                  ${getFontCss(
                    16,
                    styleConstants.colors.black,
                    styleConstants.fontFamilies.medium,
                  )};
                `}
              >
                <Trns source={'Transportation Rules'} />
              </span>
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                `}
              >
                <div
                  css={css`
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 8px;
                  `}
                >
                  <div
                    css={css`
                      display: flex;
                      align-items: center;
                    `}
                  >
                    <span
                      css={css`
                        ${getFontCss(
                          14,
                          styleConstants.colors.gray_darkest,
                          styleConstants.fontFamilies.regular,
                        )};
                      `}
                    >
                      <Trns source={'Mileage Rate'} />
                    </span>
                    <Tooltip openLeft={false}>
                      <Trns
                        source={
                          'Set the rate at which you’ll reimburse your employees for miles driven'
                        }
                      />
                    </Tooltip>
                  </div>
                  <HoverableLink
                    ariaLabel={'See current mileage rates'}
                    href={
                      'https://www.irs.gov/tax-professionals/standard-mileage-rates'
                    }
                  >
                    <span
                      css={css`
                        display: flex;
                        align-items: center;
                        ${getFontCss(
                          14,
                          themeConstants.colors.cta,
                          styleConstants.fontFamilies.regular,
                        )};
                      `}
                    >
                      <Trns source={'See current mileage rates'} />
                      <SvgExternalLink
                        css={css`
                          transform: scale(calc(16 / 24));
                        `}
                      />
                    </span>
                  </HoverableLink>
                </div>
                <span
                  css={css`
                    ${getFontCss(
                      16,
                      themeConstants.colors.font_primary,
                      styleConstants.fontFamilies.regular,
                    )};
                  `}
                >
                  {organization.mileageRateThousandths !== undefined ? (
                    <>
                      {`$${organization.mileageRateThousandths.toFixed(Math.max(2, (organization.mileageRateThousandths.toString().split('.')[1] || []).length))}/`}
                      <Trns source={'mile'} />
                    </>
                  ) : (
                    <Trns source={'No Mileage Rate Set'} />
                  )}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default OutOfPocketExpensesBoxContent
